import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitle: {
		id: 'business-issue-create.controllers.create-issue.error-flag-title',
		defaultMessage: "We weren't able to create an issue",
		description: 'Title for the flag displayed when creating an inline issue fails',
	},
	errorFlagDescription: {
		id: 'business-issue-create.controllers.create-issue.error-flag-description',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Description for the flag displayed when creating an inline issue fails',
	},
	errorFlagTitleIssueTermRefresh: {
		id: 'business-issue-create.controllers.create-issue.error-flag-title-issue-term-refresh',
		defaultMessage: "We weren't able to create a work item",
		description: 'Title for the flag displayed when creating an inline issue fails',
	},
	errorFlagTitleIssueTerminologyRefreshM4: {
		id: 'business-issue-create.controllers.create-issue.error-flag-title-issue-terminology-refresh-m4',
		defaultMessage:
			"We can't create the {workType, select, Task {task} Subtask {subtask} Story {story} Bug {bug} Epic {epic} other {{workType}}}",
		description: 'Title for the flag displayed when creating an inline issue fails',
	},
});
